<template>
    <div id="VisitorMetaReferralsCard">
        <div id="chatCard">
            <div class="headtitle">
                <span class="text">{{ $t("userInfoWidget.adsYouAreInterestedIn") }}</span>
                <div class="d-flex flex-row">
                    <a-button
                        ghost
                        @click="modaladvertisingdetail = true"
                        class="justify-content-around pl-3 popoverFont cursorPointer"
                        id="forwardButton"
                    >
                        <font-awesome-icon icon="share" style="margin-right: 5px" />
                        {{ $t("userInfoWidget.detail") }}
                    </a-button>
                </div>
            </div>
            <table>
                <thead>
                <tr>
                    <th>{{ $t("userInfoWidget.adsTitle") }}</th>
                    <th></th>
                    <th
                    >{{ $t("userInfoWidget.adUrl") }}
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="referral in ( metaReferrals || [])" :key="referral._id">
                    <td
                        style="width: 200px"
                        v-tippy="{
                                        followCursor: true,
                                        placement: 'bottom-end',
                                    }"
                        :content="referral.headline">
                        {{ referral.headline.length > 100 ? referral.headline.substring(0, 100) + "..." : referral.headline
                        }}
                    </td>
                    <td></td>
                    <td
                        v-tippy="{
                                        followCursor: true,
                                        placement: 'bottom-end',
                                    }"
                        :content="referral.sourceLink">
                            <span v-if="referral.sourceLink && referral.sourceLink.length">
                            <a :href="referral.sourceLink" target="_blank" class="text-truncate">
                                {{ referral.sourceLink }}
                            </a>
                        </span>
                        <span v-else>
                                N/A
                            </span>
                    </td>
                </tr>
                </tbody>
            </table>
            <VisitorMetaReferralsModal
                v-if="modaladvertisingdetail"
                :metaReferrals="metaReferrals"
                :modaladvertisingdetail="modaladvertisingdetail"
                @close="modaladvertisingdetail = false"
            />
        </div>
    </div>
</template>
<script>
import Modal2 from "../common/Modal2.vue";
import VisitorMetaReferralsModal from "./VisitorMetaReferralsModal.vue";

export default {
    name: "VisitorMetaReferralsCard",
    props: {
        metaReferrals: {
            type: Array,
            required: true,
        },
    },
    components: { Modal2, VisitorMetaReferralsModal },
    data() {
        return {
            modaladvertisingdetail: false,
        };
    },
};
</script>
<style lang="scss" scoped>
#VisitorMetaReferralsCard {
    margin-bottom: 10px;

    #chatCard {
        z-index: 9;
        background-color: #ffffff;
        padding: 15px 15px;
        margin-bottom: 10px;
        border-radius: 6px;

        .details-chat-card {
            &:first-child {
                margin-top: 0px !important;
            }

            .user-detail {
                display: flex;
                align-items: center;
                margin-top: 5px;

                .input-value {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    overflow: hidden;

                    .disableShortcut {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                    }

                    .edited-input {
                        display: flex;
                        justify-content: start;
                        align-items: center;
                        width: 80%;
                        margin-right: 5px;
                    }

                    .w-full {
                        text-overflow: ellipsis;
                        overflow: hidden;
                        width: 75%;
                        white-space: nowrap;
                    }
                }

                .icon {
                    margin-right: 8px;
                    color: #ffa800;
                    cursor: text;
                }
            }
        }

        .user-detail-name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .headtitle {
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .text {
            font-size: 16px;
            font-weight: 600;
            font-family: Poppins;
        }
    }

    #forwardButton {
        border: none;
        background: rgba(255, 168, 0, 0.2509803922) !important;
        color: #ffa800;
        font-weight: 600 !important;
        cursor: pointer;
        padding: 3px 7px !important;
        border-radius: 6px;
        height: 26px !important;
    }
}
.text-truncate {
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-box-orient: vertical;
}
</style>
